import { queryOptions } from '@tanstack/react-query';
import type { SystemUserListParams } from '../lib/system-user-mappers';
import { systemUserApi } from './system-user-api';

/**
 * Query-key factory + query-options for the system-user domain. Mutations
 * invalidate through `systemUserKeys` (never an inline array).
 */
export const systemUserKeys = {
  all: ['system-users'] as const,
  lists: () => [...systemUserKeys.all, 'list'] as const,
  list: (params: SystemUserListParams) => [...systemUserKeys.lists(), params] as const,
  details: () => [...systemUserKeys.all, 'detail'] as const,
  detail: (id: string) => [...systemUserKeys.details(), id] as const,
  sessions: (id: string, includeRevoked: boolean) =>
    [...systemUserKeys.all, 'sessions', id, includeRevoked] as const,
};

export const systemUserQueries = {
  list: (params: SystemUserListParams, enabled = true) =>
    queryOptions({
      queryKey: systemUserKeys.list(params),
      queryFn: () => systemUserApi.list(params),
      placeholderData: (prev) => prev,
      enabled,
    }),

  detail: (id: string, enabled = true) =>
    queryOptions({
      queryKey: systemUserKeys.detail(id),
      queryFn: () => systemUserApi.detail(id),
      enabled: enabled && id !== '',
    }),

  sessions: (id: string, includeRevoked = false, enabled = true) =>
    queryOptions({
      queryKey: systemUserKeys.sessions(id, includeRevoked),
      queryFn: () => systemUserApi.sessions(id, includeRevoked),
      enabled: enabled && id !== '',
      placeholderData: (prev) => prev,
    }),
};
